import React, { useEffect, useState, useMemo } from "react";
import SurveyListHeader from "../../../../component/common/layout/SurveyListHeader";
import { Link, useNavigate } from "react-router-dom";
import LeftSidebarNew from "../../../../component/common/layout/LeftSidebarNew";
import AccountSettingSidebar from "../../../../component/common/layout/AccountSettingSidebar";
import SearchInput from "../../../../core/Inputs/SearchInput";
import Svg from "../../../../component/common/Svg";
import Card from "../../../../core/Card";
import style from "../../../style.module.css";
import TeamsEmpty from "../empty-state/Teams";
import team1 from "../../../../assets/images/team1.jpg";
import team2 from "../../../../assets/images/team2.jpg";
import team3 from "../../../../assets/images/team3.jpg";
import team4 from "../../../../assets/images/team4.jpg";
import SurveyListSidebar from "../../../../component/common/layout/SurveyListSidebar";
import { getTokenData } from '../../../../store/actions/authAction';
import { useDispatch, useSelector } from "react-redux";
import DataTable from "react-data-table-component";
import { toast } from 'react-toastify';
import {
  deleteTeam,
  getTeamList,
  leaveTeam,
  getTeamDetail
} from "../../../../store/actions/teamAction";
import NestedMenuToggle from "../NestedMenuToggle";
import { useTranslation } from 'react-i18next';
import { addSetting, getSettingList } from "../../../../store/actions/settingsAction";


export default function Teams() {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [leaveTeamData, setLeaveTeamData] = useState(null);
  const [deleteTeamData, setDeleteTeamData] = useState(null);
  const [userId, setuserId] = useState('');
  const [serverParams, setServerParams] = useState({
    startingLimit: 0,
    resultsPerPage: 8,
    search: "",
    sort_by: "team_name",
    sort_order: "asc",
  });
  const [sortValue, setSortValue] = useState(t('settings.users_and_teams.users.edit_action.recently'));
  const sortingOptions = useMemo(() => [
    { id: 1, value: "asc", label: t('settings.users_and_teams.users.edit_action.sorta') },
    { id: 2, value: "desc", label: t('settings.users_and_teams.users.edit_action.sortb') },
  ], [i18n.language]);

  const {
    teamDataLoading: loading,
    teamData: teamList,
    teamDetail: teamDetail,
    teamMembers: teamMembers,
    totalRecords,
  } = useSelector((state) => state.teamData);

  const [isIsTeamPermission, setisIsTeamPermission] = useState(false)
  const { settingData } = useSelector((state) => state.settingData);
  // const [serverParams, setServerParams] = useState({

  const getTeams = () => {
    dispatch(getTeamList(serverParams));
  };

  console.log("teamDetail--", teamDetail)
  console.log("team member--", teamMembers)


  const columns = [
    {

      name: t('settings.team.create_team.team_name'),
      cell: (row) => {
        return (

          <div>{row.team_name}</div>
        )
      },

    },
    {

      name: t('settings.team.create_team.member'),
      // selector: 'count_user',
      cell: (row) => {
        return (

          <div>{row.count_user}</div>
        )
      },

    },
    {
      name: t('settings.users_and_teams.users.action'),
      width: '130px',
      cell: (row) => (
        <>
          <div className="d-flex action-wrapper">
            {window.modulePermissions.M5.edit === 1 && (
              <a
                className="action-btn"
                data-toggle="tooltip"
                data-placement="top"
                //title="Edit"
                onClick={() => {
                  navigate("/admin/settings/teams/edit", {
                    state: { teamId: row.team_id },
                  });
                }}
              >
                <Svg name="table-edit" />
              </a>
            )}
            {row.count_user !== 0 && (
              <a
                className="action-btn"
                data-toggle="tooltip"
                data-placement="top"
                //title="Leave"
                onClick={() => openLeaveModal(row)}
              >
                <Svg name="table-remove" />
              </a>
            )}
            {window.modulePermissions.M5.del === 1 && row.can_delete === "1" && (
              <a
                className="action-btn"
                data-toggle="tooltip"
                data-placement="top"
                //title="Delete"
                onClick={() => {
                  openDeleteModal(row);
                }}
              >
                <Svg name="table-delete" />
              </a>
            )}
          </div>

          {/* <div className="dropdown dropup">
          <button
            className="btn"
            type="button"
            id={`actions-${row.team_id}`}
            data-bs-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >
            <Svg name="action" />
          </button>
          <div className="dropdown-menu" aria-labelledby={`actions-${row.team_id}`}>
            {window.modulePermissions.M5.edit === 1 && (
              <a
                className="dropdown-item"
                onClick={() => {
                  navigate("/admin/settings/teams/edit", {
                    state: { teamId: row.team_id },
                  });
                }}
              >
                Edit
              </a>
            )}
            {row.count_user !== 0 && (
              <a
                className="dropdown-item"
                onClick={() => {
                  teamLeave(row.team_id);
                }}
              >
                Leave
              </a>
            )}
            {window.modulePermissions.M5.del === 1 && row.can_delete === 1 && (
              <a
                className="dropdown-item"
                onClick={() => {
                  openDeleteModal(row);
                }}
              >
                Delete
              </a>
            )}
          </div>
        </div> */}
        </>
      ),
    },
    // Add more columns as needed
  ];

  const teamLeave = async (teamID) => {
    let payload = { team_id: teamID, user_id: userId };
    const result = await dispatch(leaveTeam(payload));

    if (result.success) {
      await getTeams(); 
      toast.success("Leave team successfully");
    } else {
      toast.error("Failed to leave team");
    }
  };
  const dropTeam = async (teamId) => {
    const payload = { team_id: teamId };
    try {
      const result = await dispatch(deleteTeam(payload));
      if (result?.success) {
        toast.success(result.msg || "Team deleted successfully");
        closeDeleteModal();
        getTeams();
      } else {
        toast.error(result?.msg || "Failed to delete team");
      }
    } catch {
      toast.error("Failed to delete team");
    }
  };

  const openDeleteModal = (team) => {
    console.log("team", team);
    setDeleteTeamData(team);
    let deleteModal = document.getElementById("deleteModal");
    let modal = window.bootstrap.Modal.getOrCreateInstance(deleteModal);
    if (modal && !modal._isShown) {
      modal.show();
    }
  };

  const closeDeleteModal = () => {
    let deleteModal = document.getElementById("deleteModal");
    let modal = window.bootstrap.Modal.getOrCreateInstance(deleteModal);
    if (modal && modal._isShown) {
      modal.hide();
    }
    setDeleteTeamData(null);
  };


  // Called when user clicks the 'leave' icon
  const openLeaveModal = (team) => {
    setLeaveTeamData(team);                  // store the team data in state
    const leaveModal = document.getElementById("leaveModal");
    const modalInstance = window.bootstrap.Modal.getOrCreateInstance(leaveModal);
    if (modalInstance && !modalInstance._isShown) {
      modalInstance.show();
    }
  };

  const closeLeaveModal = () => {
    const leaveModal = document.getElementById("leaveModal");
    const modalInstance = window.bootstrap.Modal.getOrCreateInstance(leaveModal);
    if (modalInstance && modalInstance._isShown) {
      modalInstance.hide();
    }
    setLeaveTeamData(null);
  };


  useEffect(() => {
    setSortValue(sortingOptions[0]?.label || "");
  }, [sortingOptions]);

  useEffect(() => {
    getTeams();
  }, [serverParams]);

  console.log("teamList", teamList);

  useEffect(() => {
    // Update the state based on settingData
    if (settingData && settingData.length > 0) {
      const teamPermissionSetting = settingData[0]; // Assuming there's only one object in the array
      setisIsTeamPermission(teamPermissionSetting.value === '1');
    }
  }, [settingData]);

  const handleGetSettingList = () => {
    let payload = {
      tag: 'team',
    };
    dispatch(getSettingList(payload));
  }


  const fetchTeamDetail = async (teamId) => {
    let payload = {
      team_id: teamId,
    };
    dispatch(getTeamDetail(payload));
  };


  useEffect(() => {
    handleGetSettingList();
  }, [isIsTeamPermission])


  //Effects
  useEffect(() => {
    dispatch(getTokenData(setuserId))
  }, [userId, dispatch])



  return (
    <>
      <div className="d-flex flex-column main-outer-wrapper main-site-wrapper bg-white">
        <SurveyListHeader />
        <div id="viewport" className="d-flex bg-white">
          <SurveyListSidebar />
          <div className="flex-grow-1 d-flex">
            <AccountSettingSidebar />
            <div className="flex-grow-1 page-content-wrap d-flex flex-column">
              <div className="page-heading d-md-flex align-items-center">
                <div className="flex-grow-1">
                  {/* breadcrumbs here */}
                  <nav aria-label="breadcrumb">
                    <ol className="breadcrumb">
                      <li className="breadcrumb-item">
                        <Link to="/admin/settings/profile">{t('settings.title')}</Link>
                      </li>
                      <li className="breadcrumb-item">
                        <Link to="/admin/settings/user-permissions">{t('settings.users_and_teams.breadcrumb_heading')}</Link>
                      </li>
                      <li className="breadcrumb-item active" aria-current="page">
                        <strong>{t('settings.team.heading')}</strong>
                      </li>
                    </ol>
                  </nav>
                  {/* breadcrumbs ends here */}
                  <div className="d-flex align-items-center">
                    <NestedMenuToggle />
                    <div className="flex-grow-1 ps-3 ps-lg-0">
                      <h1>{t('settings.team.heading')}</h1>
                      <p className='pt-2 mb-0'>{t('settings.team.description')}
                      </p>
                    </div>
                  </div>
                </div>
                {window.modulePermissions.M5.add == 1 && (
                  <div className="button-wrap mt-3 mt-md-0">
                    <Link
                      to="/admin/settings/teams/create"
                      className="btn btn-primary add-btn"
                    >
                      <Svg name="plus" /> {t('settings.team.create_team.heading')}{" "}
                    </Link>
                  </div>
                )}
              </div>
              <div className="role-wrapper flex-grow-1">
                {/* Empty State of User Role */}
                {/* <TeamsEmpty /> */}

                <div className="table-wrapper-view">
                  <div className="search-filter d-md-flex align-items-center">
                    <div className="flex-grow-1 search-filter-padding">
                      <SearchInput
                        className="custom-search-input"
                        type="def"
                        view="outlined"
                        color="primary"
                        placeholder={t('settings.users_and_teams.users.search')}
                        fill={true}
                        onChange={(e) => {
                          setServerParams({
                            ...serverParams,
                            search: e.target.value,
                          });
                        }}
                        onClear={() => {
                          setServerParams({
                            ...serverParams,
                            search: "",
                          });
                        }}
                      />
                    </div>
                    <div className="drop-wrap d-flex align-items-center">
                      <label>{t('settings.team.sort_by')}
                        - </label>
                      <div className="dropdown table-dropdown ques-options">
                        <button
                          className="btn dropdown-tgl"
                          type="button"
                          id="sort"
                          data-bs-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="false"
                          key={i18n.language}
                        >
                          {sortValue}
                        </button>
                        <div className="dropdown-menu" aria-labelledby="sort">
                          {sortingOptions.map((sort) => (
                            <a
                              className="dropdown-item"
                              key={sort.id}
                              onClick={() => {
                                setServerParams({
                                  ...serverParams,
                                  sort_order: sort.value,
                                });
                                setSortValue(sort.label);
                              }}
                            >
                              {sort.label}
                            </a>
                          ))}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="teams-wrap">
                    <div className="table-responsive survey-table">
                      <div className="table-wrap custom-data-table no-width">

                        <DataTable
                          columns={columns} // Define your columns array
                          data={teamList} // Pass your team data to the datatable
                          pagination
                          paginationServer
                          paginationTotalRows={totalRecords} // Total number of records for pagination
                        // onChange={(tableState) => {
                        //   // Handle pagination and sorting changes
                        //   const { page, sortField, sortOrder, search } = tableState;
                        //   setServerParams({
                        //     ...serverParams,
                        //     startingLimit: page * serverParams.resultsPerPage,
                        //     sort_by: sortField || "team_name",
                        //     sort_order: sortOrder || "asc",
                        //     search: search || "", 
                        //   });
                        // }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className="customvar-modal modal custom-modal fade deleteModal"
        id="deleteModal"
        tabIndex={-1}
        aria-labelledby="deleteModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body">
              <div className={"formcontainer" + " " + style.container}>
                <div
                  className={
                    "formvawrapper delete-modal-wrap modal-setting-medium" +
                    " " +
                    style.wrapper
                  }
                >
                  {deleteTeamData && (
                    <Card
                      view="raised"
                      className={"formstyle p-0" + " " + style.card}
                    >
                      <div className="delete-body-wrap delete-language">
                        <div className="heading">
                          <h3>{t('settings.team.action.delete.heading')}</h3>
                        </div>
                        <div className="team-listing d-inline-flex align-items-center">
                          <div className="img-wrapper">
                            <img src={team1} alt="" className="img-fluid" />
                          </div>
                          <div className="text-wrap flex-grow-1 ps-3">
                            <h5>{deleteTeamData.team_name}</h5>
                            <p>{deleteTeamData.count_user} {t('settings.team.create_team.member')}</p>
                          </div>
                        </div>
                        <div className="warning-message">
                          <div className="title d-flex align-items-center">
                            <svg
                              width={40}
                              height={42}
                              viewBox="0 0 40 42"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M20 2L37.3205 32H2.67949L20 2Z"
                                stroke="#F05454"
                                strokeWidth={3}
                                strokeLinejoin="round"
                              />
                              <path
                                d="M20 13.5385V22"
                                stroke="#F05454"
                                strokeWidth={3}
                              />
                              <circle
                                cx="19.9994"
                                cy="25.8461"
                                r={1}
                                fill="black"
                                stroke="#F05454"
                                strokeWidth="1.07692"
                              />
                            </svg>
                            <h4>{t('settings.team.action.delete.warning')}</h4>
                          </div>
                          <p>
                            {t('settings.team.action.delete.text')}
                          </p>
                        </div>

                        <div className="button-wrap d-flex justify-content-end">
                          <button
                            type="button"
                            className="btn btn-bordered color-delete"
                            onClick={() => {
                              closeDeleteModal();
                            }}
                          >
                            {t('settings.team.action.delete.cancel')}

                          </button>
                          <button
                            type="button"
                            className="btn btn-delete ms-3"
                            onClick={() => {
                              dropTeam(deleteTeamData.team_id);
                            }}
                          >
                            {t('settings.team.action.delete.confirm_delete')}

                          </button>
                        </div>
                      </div>
                    </Card>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Leave Team Confirmation Modal */}
      <div
        className="customvar-modal modal custom-modal fade deleteModal"
        id="leaveModal"
        tabIndex={-1}
        aria-labelledby="leaveModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered ">
          <div className="modal-content">
            <div className="modal-body">
              <div className={"formcontainer " + style.container}>
                <div className={"formvawrapper delete-modal-wrap " + style.wrapper}>
                  {leaveTeamData && (
                    <Card view="raised" className={"formstyle p-0 " + style.card}>
                      <div className="delete-body-wrap delete-language">
                        <div className="heading">
                          <h3>Leave Team</h3>
                          <p>Are you sure you want to leave this team?</p>
                        </div>
                       
                        
                        <div className="button-wrap d-flex justify-content-end">
                          <button
                            type="button"
                            className="btn btn-bordered"
                            onClick={closeLeaveModal}
                          >
                           {t('settings.team.action.delete.cancel')}
                          </button>
                          <button
                            type="button"
                            className="btn btn-delete ms-3"
                            onClick={async () => {
                              await teamLeave(leaveTeamData.team_id);
                              closeLeaveModal();
                            }}
                          >
                             {t('settings.team.action.delete.confirm_delete')}
                          </button>
                        </div>
                      </div>
                    </Card>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </>
  );
}
